import React from 'react';
import { Provider } from "react-redux";
import { render } from "react-dom";
// AZURE PACKAGE CHANGE
import { MsalProvider } from "@azure/msal-react";
import configureStore from "./config/configureStore";
// AZURE PACKAGE CONFIG FILE
import { msalInstance } from "./config/msal/authConfig";
import App from './App';

export const store = configureStore();

const renderApp = () =>
    render(
        <MsalProvider instance={msalInstance}>
            <Provider store={store}>
                <App />
            </Provider>
        </MsalProvider>
        ,
        document.getElementById('root')
    );
    

renderApp();